import type { InternalDropdownOptions } from '~/chords/DropdownSingleSelect/types';
import { doesLabelMatchSearchTerm } from '~/chords/DropdownSingleSelect/utils/findSearchTermWordCover';
import { getSearchMatchTokens } from '~/chords/DropdownSingleSelect/utils/getSearchMatchTokens';

/**
 * Recursively update isVisible=true|false on the options array based on search terms.
 * Supports both flat and grouped (nested) option arrays.
 * @param options - The options to update (flat or grouped).
 * @param param1.searchQueryTrimmed - The trimmed search query.
 * @returns The updated options.
 */
export function updateIsVisibleSearch(
  options: InternalDropdownOptions,
  { searchQueryTrimmed }: { searchQueryTrimmed: string },
): InternalDropdownOptions {
  const searchTerms = getSearchMatchTokens(searchQueryTrimmed);

  return options.map((group) => {
    const internalOptionsGroup = 'options' in group ? group.options : group;
    const updatedOptionsGroup = internalOptionsGroup.map((option) => {
      const optionLabel = option.label || option.value;
      const isMatched =
        !searchQueryTrimmed ||
        searchTerms.some((term) => doesLabelMatchSearchTerm(optionLabel, term));

      return {
        ...option,
        isVisible: isMatched,
      };
    });

    if ('options' in group) {
      return {
        ...group,
        options: updatedOptionsGroup,
      };
    }

    return updatedOptionsGroup;
  });
}
